/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface IncomeTypeDto
 */
export interface IncomeTypeDto {
  /**
   *
   * @type {string}
   * @memberof IncomeTypeDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof IncomeTypeDto
   */
  name: string;
}

export function IncomeTypeDtoFromJSON(json: any): IncomeTypeDto {
  return IncomeTypeDtoFromJSONTyped(json, false);
}

export function IncomeTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncomeTypeDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
  };
}

export function IncomeTypeDtoToJSON(value?: IncomeTypeDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    name: value.name,
  };
}
